import React from 'react'

function ProviderIDManagerView({providers,removeProvider,showActionColumn=true}) {
  return (
    <div className="card mt-4 border-0">
        <div className="card-body p-0">
          <table className="table align-middle" style={{minHeight: '246px'}}>
            <thead className="table-light text-warning">
              <tr className="form-label-warning">
                <th>Provider ID Type</th>
                <th>Provider ID</th>
                {showActionColumn ? <th className="text-end"></th>:<></>}
              </tr>
            </thead>
            <tbody>
              {providers.map((provider, index) => (
                <tr key={index}>
                  <td className="">{provider.type}</td>
                  <td className="">{provider.id}</td>
                  {showActionColumn ? <td className="text-end">
                    {/* Delete Button */}
                    <div
                      onClick={() => removeProvider(index)}
                      style={{
                        cursor: 'pointer'
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M10 11v6M14 11v6M5 6h14v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6z" />
                      </svg>
                    </div>
                  </td>:<></>}
                </tr>
              ))}
            </tbody>
          </table>
          {providers.length === 0 && (
            <p className="text-center text-muted">No providers added yet.</p>
          )}
        </div>
      </div>
  )
}

export default ProviderIDManagerView
